var app_categories_table = $('#app-categories-table');

if (app_categories_table.length) {
    var data_table_order = [0, "asc"];
    var categoriesTableObj = null;

    function initializeCategoriesTable() {
        console.log('$$$$$$$$$$$$$$$$$ ', user_entries, data_table_order);
        categoriesTableObj = window.app_categories_table
            .DataTable({
                ajax: {
                    url: '/categories/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'name'},//0
                    {data: 'subcategories'},//1
                    {data: 'created_by'},//2
                    {data: 'updated_at'},//3
                    {data: 'id'}//4
                ],
                pageLength: user_entries,
                order: data_table_order,
                destroy: true,
                "columnDefs": [{
                    "targets": 0,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.name);
                    }
                },{
                    "targets": 1,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if(typeof rowData.subcategories !== 'undefined') {
                            for(var i in rowData.subcategories)
                                html += rowData.subcategories[i].name + (i !== rowData.subcategories.length - 1 ? ', ' : '')
                        }
                        $(td).html(html);
                    }
                }, {
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.user.name);
                    }
                },{
                    "targets": 3,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.updated_at);
                    }
                }, {
                    "targets": 4,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        var deleteButton = ''
                        if (table_editable) {
                            deleteButton += '<li class="ms-hover"><a href="javascript:void(0)" onclick="deleteCategory(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                '<i class="fa fa-trash-o"></i> Delete ' +
                                '</a></li>';
                        }

                        html += '</div>';

                        var html = '<div class="btn-group">\n' +
                            '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                            '                <i class="fa fa-ellipsis-v"></i>\n' +
                            '                <span class="sr-only">Toggle Dropdown</span>\n' +
                            '            </button>\n' +
                            '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                            '                <li class="ms-hover">' + '<a href="/categories/' + cellData + '/edit" role="button" class="btn btn-success btn-sm">' + '<i class="fa fa-pencil"></i> Edit ' + '</a>' + '</li>\n' +
                            deleteButton + '\n' +
                            '                <li role="separator" class="divider ms-hover"></li>\n' +
                            '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                        '            </ul>\n' +
                        '        </div>';
                        $(td).html(html);
                    }
                }]
            });
    }

    $('#app-categories-table').on('length.dt', function (e, settings, len) {
        user_entries = len;
    });
    $('#app-categories-table').on('order.dt', function (e, settings, len) {
        data_table_order = [len[0].col, "" + len[0].dir + ""];
    });


    function deleteCategory(urlVar) {
        $('#deleteCategoryConfirmed').attr('data-url', urlVar);
        $('#deleteCategoryWarningModal').modal('show');
    }

    function deleteCategoryConfirmed() {
        var urlVar = $('#deleteCategoryConfirmed').attr('data-url');
        show_loader();
        $.ajax({
            url: '/categories/' + urlVar + '/destroy',
            success: function (response) {
                global_notification('success', 'Category deleted.')
                initializeCategoriesTable();
                $('#deleteCategoryWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    initializeCategoriesTable();
}

var app_prod_categories_table = $('#app-prod-categories-table');

if (app_prod_categories_table.length) {
    var data_table_order = [0, "asc"];
    var categoriesProdTableObj = null;

    function initializeProdCategoriesTable() {
        console.log('$$$$$$$$$$$$$$$$$ ', user_entries, data_table_order);
        categoriesProdTableObj = window.app_prod_categories_table
            .DataTable({
                ajax: {
                    url: '/prod-categories/list',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'name'},//0
                    {data: 'subcategories'},//1
                    {data: 'created_by'},//2
                    {data: 'updated_at'},//3
                    {data: 'id'}//4
                ],
                pageLength: user_entries,
                order: data_table_order,
                destroy: true,
                "columnDefs": [{
                    "targets": 0,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.name);
                    }
                }, {
                    "targets": 1,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if (typeof rowData.subcategories !== 'undefined') {
                            for (var i in rowData.subcategories)
                                html += rowData.subcategories[i].name + (i !== rowData.subcategories.length - 1 ? ', ' : '')
                        }
                        $(td).html(html);
                    }
                }, {
                    "targets": 2,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.user.name);
                    }
                }, {
                    "targets": 3,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(rowData.updated_at);
                    }
                }, {
                    "targets": 4,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        var deleteButton = ''
                        if (table_editable) {
                            deleteButton += '<li class="ms-hover"><a href="javascript:void(0)" onclick="deleteProdCategory(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                '<i class="fa fa-trash-o"></i> Delete ' +
                                '</a></li>';
                        }

                        html += '</div>';

                        var html = '<div class="btn-group">\n' +
                            '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                            '                <i class="fa fa-ellipsis-v"></i>\n' +
                            '                <span class="sr-only">Toggle Dropdown</span>\n' +
                            '            </button>\n' +
                            '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                            '                <li class="ms-hover">' + '<a href="/prod-categories/' + cellData + '/edit" role="button" class="btn btn-success btn-sm">' + '<i class="fa fa-pencil"></i> Edit ' + '</a>' + '</li>\n' +
                            deleteButton + '\n' +
                            '                <li role="separator" class="divider ms-hover"></li>\n' +
                            '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                        '            </ul>\n' +
                        '        </div>';
                        $(td).html(html);
                    }
                }]
            });
    }

    $('#app-prod-categories-table').on('length.dt', function (e, settings, len) {
        user_entries = len;
    });
    $('#app-prod-categories-table').on('order.dt', function (e, settings, len) {
        data_table_order = [len[0].col, "" + len[0].dir + ""];
    });


    function deleteProdCategory(urlVar) {
        $('#deleteProdCategoryConfirmed').attr('data-url', urlVar);
        $('#deleteProdCategoryWarningModal').modal('show');
    }

    function deleteProdCategoryConfirmed() {
        var urlVar = $('#deleteProdCategoryConfirmed').attr('data-url');
        show_loader();
        $.ajax({
            url: '/prod-categories/' + urlVar + '/destroy',
            success: function (response) {
                global_notification('success', 'Category deleted.')
                initializeProdCategoriesTable();
                $('#deleteProdCategoryWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    initializeProdCategoriesTable();
}